<form id="permanent_planning_delete" [formGroup]="this.permanentPlanningDeleteForm" (ngSubmit)="this.delete()">
    
    <div class="title_card">{{'DELETE_PLANNING' | translate}}</div>   
    
    @if(this.msgError){
        <marv-message type="error">{{this.msgError}}</marv-message>
    }
    
    <div id="permanent_planning_delete_form">
        
        <div class="title_form">
            <marv-section-title label="{{'FILTER_ITEMS' | translate}}"/>
            <marv-button type="button" [rounded]="true" icon="search-outline" color="primary" [isFetching]="this.isFetchingPlanning" (click)="this.loadPlanning()" />
        </div>
        <marv-input-date 
            label="{{ 'START_DATE' | translate }}" 
            formName="startDate"            
            [withSpeechToText]="true"           
            class="field_date"
            />   
        <marv-input-date 
            label="{{ 'END_DATE' | translate }}" 
            formName="endDate"            
            [withSpeechToText]="true" 
            class="field_date"
            /> 
        <marv-select label="{{ 'AGENTS' | translate }}" icon="person-outline" formName="agentsId" [items]="this.agentsItems" [multiple]="true"></marv-select>
        <marv-toggle label="{{'INCLUDE_EVENTS' | translate}}" formName="includeEvents" labelPlacement="end" />
        
        <div class="title_form">
            <marv-section-title label="{{'ITEMS_TO_DELETE' | translate}}"/>
            <marv-checkbox                
                formName="checkAllItems" 
                [inline]="true" 
                /> 
        </div>
        
        @if(this.isFetchingPlanning){
            <div class="bloc_loading_items">
                <ion-spinner></ion-spinner>
            </div>
        }
        @else{
            @if(this.planningItems.length > 0){
                <div id="planning_items">
                    @for(agent of this.planningItems; track $index){
                        <marv-sub-item>
                            <div class="agent_name">
                                {{agent.salesRepName}}
                                <marv-checkbox                
                                    [formName]="'checkAllAgent_'+agent.salesRepId" 
                                    [inline]="true" 
                                    /> 
                            </div>
                            @for(item of agent.items; track $index){
                                <div class="planning_item">
                                    <marv-checkbox                
                                        [formName]="'checkItem_'+item.id" 
                                        [inline]="true" 
                                        /> 
                                    {{item.date | marvDateToString: 'DD/MM/YYYY HH:mm'}} - {{item.title}}
                                </div>
                            }
                        </marv-sub-item>
                    }
                </div>
            }
            @else{
                <marv-message type="info">{{ 'MSG_NO_ITEM_TO_DELETE' | translate }}</marv-message>
            }
        }
        
    </div>
    
    <ion-grid id="footer_permanent_planning_delete">
        <ion-row class="ion-justify-content-around">
            <ion-col size="auto">
                <marv-button type="submit" label="{{ 'DELETE' | translate }}" icon="trash-outline" color="red" [disabled]="this.planningItems.length === 0" [isFetching]="this.isFetchingDelete"/>
            </ion-col>
            <ion-col size="auto">
                <marv-button type="button" label="{{ 'CANCEL' | translate }}" icon="close-outline" color="secondary" (click)="this.cancel()" />
            </ion-col>
        </ion-row>
    </ion-grid>
    
</form>